import store from '@/store';
import queueStore from './queue-store';

const exports = {
  namespace: 'offline',
  module: {
    namespaced: true,
    state     : {
      isOnline: true
    },
    mutations : {
      SET_IS_ONLINE: (state, status) => state.isOnline = status
    },
    actions   : {
      setIsOnline
    },
    getters   : {
    }
  }
};

store.registerModule(exports.namespace.split('/'), exports.module);

export default exports;

//////////

function setIsOnline({commit, state}, status) {

  if(status !== state.isOnline) {
    commit('SET_IS_ONLINE', status);
  }

  if(status) {
    store.dispatch(`${queueStore.namespace}/runQueue`);
  }

}
